import ExcelJS from 'exceljs';

export default async function downloadSheet(client, racksList) {
    const workbook = new ExcelJS.Workbook();

    const worksheetProjects = workbook.addWorksheet('Racks');
    worksheetProjects.columns = [
        { header: 'SITE', key: 'site', width: 15 },
        { header: 'DH', key: 'dh', width: 10 },
        { header: 'SCALA RACK NAME', key: 'rack', width: 20 },
        { header: 'CLIENT RACK NAME', key: 'rackClient', width: 20 },
        { header: 'STATUS', key: 'status', width: 12 },
        { header: 'CAGE', key: 'cage', width: 20 },
        { header: 'CREATED', key: 'created', width: 15 },
        { header: 'ROW - Y AXIS', key: 'row', width: 15 },
        { header: 'POSITIONS - X AXIS', key: 'position', width: 20 },
        { header: 'OCCUPPATION', key: 'ocuppation', width: 20 },
        { header: 'POWER', key: 'power', width: 10 },
        { header: 'CLASSIFICATION', key: 'classification', width: 15 },
        { header: 'PDU', key: 'pdu', width: 50 },
    ];

    worksheetProjects.getRow(1).eachCell((cell) => {
        cell.style = {
            fill: {
                type: 'pattern',
                pattern:'solid',
                fgColor:{ argb:'64afff' }
            },
        };
    });

    racksList.forEach(site => {
        site.racks.forEach(value => {
            const row = {
                site: site.siteName,
                dh: value.room.room,
                rack: value.nscala,
                rackClient: value.nrack,
                status: value.status ? 'Added' : 'Churned',
                cage: value.cage?.name ? value.cage.name : 'No Cage',
                created: new Date(value.createdAt).toLocaleDateString(),
                row: value?.fileira,
                position: value?.posicao,
                ocuppation: value?.ocupacao,
                power: value?.potenciaContratada,
                classification: value?.classification == null ? 'N/A': value?.classification,
                pdu: value.pduRacks.length > 0 ? value.pduRacks.map(pdu => (`(${pdu.name} | ${pdu.circuito})`)) : 'No PDUs'
            };
            worksheetProjects.addRow(row);
        })
    });

    const formatDate = (date) => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const fileName = `RackCount - ${client} - ${formatDate(new Date())}.xlsx`;

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
};